import { render } from "./CarDetail.vue?vue&type=template&id=4eed0b0e&scoped=true"
import script from "./CarDetail.vue?vue&type=script&lang=js"
export * from "./CarDetail.vue?vue&type=script&lang=js"

import "./CarDetail.vue?vue&type=style&index=0&id=4eed0b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eed0b0e"]])

export default __exports__